import { FC } from 'react';
import Ratings from 'react-ratings-declarative';
// import { Link } from 'react-router-dom';
import { findStyleGarment, findStyleGarmentMaster } from '../../garments';
import ScrollToTopOnMount from '../../template/ScrollToTopOnMount';
import { FitroomWidget } from '../../widget/fitroomWidget';
import type { FitroomSessionResPayload } from '../../widget/fitroomWidgetTypes';
import { useProductDetail, useProductRelated } from './ProductDetail.hooks';
import {
  sendFitroomAvatarReq,
  sendFitroomGarmentReq,
  sendFitroomSessionReq,
} from './ProductDetailFitroom';
import RelatedProduct from './RelatedProduct';

const iconPath =
  'M18.571 7.221c0 0.201-0.145 0.391-0.29 0.536l-4.051 3.951 0.96 5.58c0.011 0.078 0.011 0.145 0.011 0.223 0 0.29-0.134 0.558-0.458 0.558-0.156 0-0.313-0.056-0.446-0.134l-5.011-2.634-5.011 2.634c-0.145 0.078-0.29 0.134-0.446 0.134-0.324 0-0.469-0.268-0.469-0.558 0-0.078 0.011-0.145 0.022-0.223l0.96-5.58-4.063-3.951c-0.134-0.145-0.279-0.335-0.279-0.536 0-0.335 0.346-0.469 0.625-0.513l5.603-0.815 2.511-5.078c0.1-0.212 0.29-0.458 0.547-0.458s0.446 0.246 0.547 0.458l2.511 5.078 5.603 0.815c0.268 0.045 0.625 0.179 0.625 0.513z';

const ProductDetail: FC = () => {
  const { featured } = useProductRelated();
  const {
    garment,
    image,
    productId,
    setImage,
    setSize,
    setVariant,
    // setWidgetLoaded,
    size,
    sizes,
    style,
    variant,
    variants,
  } = useProductDetail();

  function changeRating(_) {}

  return (
    // Using key forces the page to unmount and mount when the product changes
    <div className="container mt-5 py-4 px-xl-5" key={productId}>
      <ScrollToTopOnMount />
      {/* <nav aria-label="breadcrumb" className="bg-custom-light rounded mb-4">
        <ol className="breadcrumb p-3">
          <li className="breadcrumb-item">
            <Link className="text-decoration-none link-secondary" to="/products">
              All Products
            </Link>
          </li>
          <li className="breadcrumb-item">
            <a className="text-decoration-none link-secondary" href="!#">
              Cases &amp; Covers
            </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Nillkin iPhone X cover
          </li>
        </ol>
      </nav> */}
      <div className="row mb-4">
        <div className="d-none d-lg-block col-lg-1">
          <div className="image-vertical-scroller">
            <div className="d-flex flex-column">
              {Array.from({ length: 5 }, (_, i) => {
                let selected = i === image ? 'border-primary' : '';
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setImage(i);
                    }}
                  >
                    <img
                      className={'border rounded mb-2 ratio variant ' + selected}
                      alt=""
                      role="button"
                      src={garment?.preview}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="row">
            <div className="col-12 mb-4">
              <img className="border rounded ratio ratio-1x1" alt="" src={garment?.preview} />
            </div>
          </div>

          {/* <div className="row mt-2">
            <div className="col-12">
              <div
                className="d-flex flex-nowrap"
                style={{ overflowX: "scroll" }}
              >
                {Array.from({ length: 8 }, (_, i) => {
                  return (
                    <a key={i} href="!#">
                      <img
                        className="cover rounded mb-2 me-2"
                        width="70"
                        height="70"
                        alt=""
                        src={Image}
                      />
                    </a>
                  );
                })}
              </div>
            </div>
          </div> */}
        </div>

        <div className="col-lg-5">
          <div className="d-flex flex-column h-100">
            <h2 className="mb-1">{style?.name}</h2>
            <h4 className="text-muted mb-4">1000$</h4>

            <div className="row g-3 mb-4">
              <div className="col">
                <button className="btn btn-outline-dark py-2 w-100">Add to cart</button>
              </div>
              <div className="col">
                <button className="btn btn-dark py-2 w-100">Buy now</button>
              </div>
            </div>

            <h4 className="mb-0">Details</h4>
            <hr />
            <dl className="row">
              <dt className="col-sm-4">Code</dt>
              <dd className="col-sm-8 mb-3">{style?.code || 'Undefined'}</dd>

              <dt className="col-sm-4">Category</dt>
              <dd className="col-sm-8 mb-3">{style?.taxonomy || 'Undefined'}</dd>

              <dt className="col-sm-4">Brand</dt>
              <dd className="col-sm-8 mb-3">{style?.brand || 'Undefined'}</dd>

              <dt className="col-sm-4">Rating</dt>
              <dd className="col-sm-8 mb-3">
                <Ratings
                  rating={4.5}
                  widgetRatedColors="rgb(253, 204, 13)"
                  changeRating={changeRating}
                  widgetSpacings="2px"
                >
                  {Array.from({ length: 5 }, (_, i) => {
                    return (
                      <Ratings.Widget
                        key={i}
                        widgetDimension="20px"
                        svgIconViewBox="0 0 19 20"
                        svgIconPath={iconPath}
                        widgetHoverColor="rgb(253, 204, 13)"
                      />
                    );
                  })}
                </Ratings>
              </dd>

              <dt className="col-sm-4">Color</dt>
              <dd className="col-sm-8 mb-3">
                <div className="row row-cols-md-4 g-1">
                  {variants.map((v, i) => {
                    const selected = v.name === variant ? 'border-primary' : '';
                    return (
                      <div
                        key={v.name}
                        onClick={() => {
                          setVariant(v.name);
                          if (!style) {
                            return;
                          }
                          // Find match preserving size first, then master.
                          let g = findStyleGarment(style, size!, v.name);
                          const isSizeRecommendation = !Boolean(g);
                          g = g ?? findStyleGarmentMaster(style, v.name)!;
                          // Send to widget.
                          sendFitroomGarmentReq(g.id, isSizeRecommendation);
                        }}
                      >
                        <img
                          className={'border rounded mr-3 ratio variant ' + selected}
                          alt={v.name}
                          role="button"
                          src={v.image}
                        />
                      </div>
                    );
                  })}
                </div>
              </dd>

              <dt className="col-sm-4">Size</dt>
              <dd className="col-sm-8 mb-3">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={event => {
                    const size = event.target.value;
                    setSize(size);
                    if (!size) {
                      return;
                    }
                    // Find garment.
                    const g = findStyleGarment(style!, size, variant!)!;
                    // Send to widget.
                    sendFitroomGarmentReq(g.id, false);
                  }}
                  value={size ?? ''}
                >
                  <option value="">Select size</option>
                  {sizes.map(s => (
                    <option disabled={s.disabled} key={s.name} value={s.name}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </dd>
            </dl>

            <h4 className="mb-0">Description</h4>
            <hr />
            <p className="lead flex-shrink-0">
              <small>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </small>
            </p>

            <h4 className="mb-0">Evaluate Fit</h4>
            <hr />
            <dd className="col shadow-sm w-100 widget">
              <FitroomWidget
                onGarmentUpdated={(garmentId: string) => {
                  const g = style!.variants.find(g => g.id === garmentId);
                  setSize(g!.size);
                  setVariant(g!.variant);
                }}
                onLoaded={() => {
                  sendFitroomSessionReq();
                }}
                onSessionResponse={(data: FitroomSessionResPayload) => {
                  // setWidgetLoaded(true);
                  // Send avatar if widget session did not provide it.
                  if (!data.avatarId) {
                    sendFitroomAvatarReq();
                  }
                  sendFitroomGarmentReq(garment!.id, true);
                }}
              />
            </dd>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mb-4">
          <hr />
          <h4 className="text-muted my-4">Related products</h4>
          <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3">
            {featured.map((p, i) => {
              return (
                <RelatedProduct
                  key={i}
                  id={p.id}
                  image={p.image}
                  name={p.name}
                  percentOff={i % 2 === 0 ? 15 : null}
                  price={p.price}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
